<template>
    <div class="response" id="response">
        <div class="comment" v-for="item in this.comment">
            <h2>{{ item.title }}</h2>
            <h3 v-if="item.author && item.author.length != 0">
                点评专家：<span v-for="item2 in item.author">{{ item2 }} </span>,<span v-for="item2 in item.aff">{{ item2 }} </span>
            </h3>
            <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                response: [],
                comment: []
            }
        },
        created() {
            this.response = this.ARTICLE.response
            for(var i in this.response){
                if(this.response[i].type == 'comment'){
                    this.comment.push(this.response[i])
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
h3{
    margin: 1rem 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/response/response.vue